//Adapted from https://github.com/antefact/microBit.js

var ACCEL_SRV = 'e95d0753-251d-470a-a062-fa1922dfa9a8';
var ACCEL_DATA = 'e95dca4b-251d-470a-a062-fa1922dfa9a8';
// var ACCEL_PERIOD = 'e95dfb24-251d-470a-a062-fa1922dfa9a8';
var MAGNETO_SRV = 'e95df2d8-251d-470a-a062-fa1922dfa9a8';
var MAGNETO_DATA = 'e95dfb11-251d-470a-a062-fa1922dfa9a8';
// var MAGNETO_PERIOD = 'e95d386c-251d-470a-a062-fa1922dfa9a8';
var MAGNETO_BEARING = 'e95d9715-251d-470a-a062-fa1922dfa9a8';
var BTN_SRV = 'e95d9882-251d-470a-a062-fa1922dfa9a8';
var BTN_A_STATE = 'e95dda90-251d-470a-a062-fa1922dfa9a8';
var BTN_B_STATE = 'e95dda91-251d-470a-a062-fa1922dfa9a8';
var IO_PIN_SRV = 'e95d127b-251d-470a-a062-fa1922dfa9a8';
var IO_PIN_DATA = 'e95d8d00-251d-470a-a062-fa1922dfa9a8';
var IO_AD_CONFIG = 'e95d5899-251d-470a-a062-fa1922dfa9a8';
var IO_PIN_CONFIG = 'e95db9fe-251d-470a-a062-fa1922dfa9a8';
var IO_PIN_PWM = 'e95dd822-251d-470a-a062-fa1922dfa9a8';
var LED_SRV = 'e95dd91d-251d-470a-a062-fa1922dfa9a8';
var LED_STATE = 'e95d7b77-251d-470a-a062-fa1922dfa9a8';
var LED_TEXT = 'e95d93ee-251d-470a-a062-fa1922dfa9a8';
var LED_SCROLL = 'e95d0d2d-251d-470a-a062-fa1922dfa9a8';
var TEMP_SRV = 'e95d6100-251d-470a-a062-fa1922dfa9a8';
var TEMP_DATA = 'e95d9250-251d-470a-a062-fa1922dfa9a8';
// var TEMP_PERIOD = 'e95d1b25-251d-470a-a062-fa1922dfa9a8';

class Microbit {
	constructor(callbacks) {
		this.callbacks = {
			buttonA: () => {},
			buttonB: () => {},
			onConnect: () => {},
			onDisconnect: () => {},
			onBleNotify: () => {},
			accelerometer: () => {},
			magnetometerRaw: () => {},
			magnetometerBearing: () => {},
			temperature: () => {},
			...callbacks,
		};
		this.accelerometer = {
			x: 0,
			y: 0,
			z: 0,
		};

		this.magnetometer_raw = {
			x: 0,
			y: 0,
			z: 0,
		};

		this.magnetometer_bearing = 0;
		this.temperature = 0;

		this.buttonA = 0;

		this.buttonB = 0;

		this.connected = false;

		this.characteristic = {
			IO_PIN_DATA: {},
			IO_AD_CONFIG: {},
			IO_PIN_CONFIG: {},
			IO_PIN_PWM: {},
			LED_STATE: {},
			LED_TEXT: {},
			LED_SCROLL: {},
		};
	}

	getTemperature() {
		return this.temperature;
	}

	getAccelerometer() {
		return this.accelerometer;
	}

	getBearing() {
		return this.magnetometer_bearing;
	}

	getButtonA() {
		return this.buttonA;
	}

	getButtonB() {
		return this.buttonB;
	}

	writeMatrixIcon(icon) {
		var ledMatrix = new Int8Array(5);
		var buffer = [
			['0', '0', '0', '0', '0', '0', '0', '0'],
			['0', '0', '0', '0', '0', '0', '0', '0'],
			['0', '0', '0', '0', '0', '0', '0', '0'],
			['0', '0', '0', '0', '0', '0', '0', '0'],
			['0', '0', '0', '0', '0', '0', '0', '0'],
		];
		for (let i = 0; i < 5; i++) {
			for (var j = 0; j < 5; j++) {
				buffer[i][7 - j] = icon[i][4 - j];
			}
		}
		for (let i = 0; i < 5; i++) {
			var string = buffer[i].join('');
			ledMatrix[i] = parseInt(string, 2);
		}
		if (this.connected) {
			this.characteristic.LED_STATE.writeValue(ledMatrix)
				.then(() => {})
				.catch(error => {
					this.log(error);
				});
		}
	}

	writeMatrixTextSpeed(speed) {
		var buffer = new Uint8Array(speed);
		if (this.connected) {
			this.characteristic.LED_TEXT.writeValue(buffer)
				.then(() => {})
				.catch(error => {
					this.log(error);
				});
		}
	}

	writeMatrixText(str) {
		var buffer = new Uint8Array(toUTF8Array(str));
		if (this.connected) {
			this.characteristic.LED_TEXT.writeValue(buffer)
				.then(() => {})
				.catch(error => {
					this.log(error);
				});
		}
	}

	characteristic_updated(event) {
		this.callbacks.onBleNotify();
		//BUTTON CHARACTERISTIC
		if (event.target.uuid === BTN_A_STATE) {
			//this.log("BTN_A_STATE", event.target.value.getInt8());
			this.buttonA = event.target.value.getInt8();
			if (this.buttonA) {
				this.callbacks.buttonA();
			}
		}

		if (event.target.uuid === BTN_B_STATE) {
			//this.log("BTN_B_STATE", event.target.value.getInt8());
			this.buttonB = event.target.value.getInt8();
			if (this.buttonB) {
				this.callbacks.buttonB();
			}
		}

		//ACCELEROMETER CHARACTERISTIC
		if (event.target.uuid === ACCEL_DATA) {
			//true is for reading the bits as little-endian
			//this.log("ACCEL_DATA_X", event.target.value.getInt16(0,true));
			//this.log("ACCEL_DATA_Y", event.target.value.getInt16(2,true));
			//this.log("ACCEL_DATA_Z", event.target.value.getInt16(4,true));
			this.accelerometer.x = event.target.value.getInt16(0, true);
			this.accelerometer.y = event.target.value.getInt16(2, true);
			this.accelerometer.z = event.target.value.getInt16(4, true);
			this.callbacks.accelerometer({
				...this.accelerometer,
			});
		}

		// MAGNETOMETER CHARACTERISTIC (raw data)
		if (event.target.uuid === MAGNETO_DATA) {
			//  this.log("MAGNETO_DATA_X", event.target.value.getInt16(0,true));
			//  this.log("MAGNETO_DATA_Y", event.target.value.getInt16(2,true));
			//  this.log("MAGNETO_DATA_Z", event.target.value.getInt16(4,true));
			this.magnetometer_raw.x = event.target.value.getInt16(0, true);
			this.magnetometer_raw.y = event.target.value.getInt16(2, true);
			this.magnetometer_raw.z = event.target.value.getInt16(4, true);
			this.callbacks.magnetometerRaw({
				...this.magnetometer_raw,
			});
		}

		// MAGNETOMETER CHARACTERISTIC (bearing)
		if (event.target.uuid === MAGNETO_BEARING) {
			//this.log("BEARING", event.target.value.getInt16(0,true));
			this.magnetometer_bearing = event.target.value.getInt16(0, true);
			this.callbacks.magnetometerBearing(this.magnetometer_bearing);
		}

		// TEMPERATURE CHARACTERISTIC
		if (event.target.uuid === TEMP_DATA) {
			//this.log("TEMP_DATA", event.target.value.getInt8());
			this.temperature = event.target.value.getInt8();
			this.callbacks.temperature(this.temperature);
		}
	}

	searchDevice() {
		var options = {};
		options.acceptAllDevices = true;
		options.optionalServices = [
			ACCEL_SRV,
			MAGNETO_SRV,
			BTN_SRV,
			IO_PIN_SRV,
			LED_SRV,
			TEMP_SRV,
		];

		this.log('Requesting Bluetooth Device...');
		this.log('with ' + JSON.stringify(options));

		navigator.bluetooth
			.requestDevice(options)
			.then(device => {
				this.log('> Name:             ' + device.name);
				this.log('> Id:               ' + device.id);

				device.addEventListener(
					'gattserverdisconnected',
					this.callbacks.onDisconnect,
				);

				// Attempts to connect to remote GATT Server.
				return device.gatt.connect();
			})
			.then(server => {
				// Note that we could also get all services that match a specific UUID by
				// passing it to getPrimaryServices().
				this.callbacks.onConnect();
				this.log('Getting Services...');
				return server.getPrimaryServices();
			})
			.then(services => {
				this.log('Getting Characteristics...');
				let queue = Promise.resolve();
				services.forEach(service => {
					queue = queue.then(() =>
						service.getCharacteristics().then(characteristics => {
							this.log('> Service: ' + service.uuid);
							characteristics.forEach(characteristic => {
								this.log(
									'>> Characteristic: ' +
										characteristic.uuid +
										' ' +
										getSupportedProperties(characteristic),
								);

								//need to store all the characteristic I want to write to be able to access them later.
								switch (characteristic.uuid) {
									case IO_PIN_DATA:
										this.characteristic.IO_PIN_DATA = characteristic;
										break;

									case IO_AD_CONFIG:
										this.characteristic.IO_AD_CONFIG = characteristic;
										break;

									case IO_PIN_CONFIG:
										this.characteristic.IO_PIN_CONFIG = characteristic;
										break;

									case IO_PIN_PWM:
										this.characteristic.IO_PIN_PWM = characteristic;
										break;

									case LED_STATE:
										this.characteristic.LED_STATE = characteristic;
										this.connected = true;

										break;

									case LED_TEXT:
										this.characteristic.LED_TEXT = characteristic;
										break;

									case LED_SCROLL:
										this.characteristic.LED_SCROLL = characteristic;
										break;

									default:
								}

								if (
									getSupportedProperties(
										characteristic,
									).includes('NOTIFY')
								) {
									characteristic
										.startNotifications()
										.catch(err =>
											this.log(
												'startNotifications',
												err,
											),
										);
									characteristic.addEventListener(
										'characteristicvaluechanged',
										this.characteristic_updated.bind(this),
									);
								}
							});
						}),
					);
				});
				return queue;
			})
			.catch(error => {
				this.log('Argh! ' + error);
			});
	}

	log(...args) {
		console.log(...args); //eslint-disable-line
	}
}

export default Microbit;

/* Utils */
export const isWebBluetoothEnabled = () => {
	if (navigator.bluetooth) {
		return true;
	} else {
		// ChromeSamples.setStatus(
		// 	'Web Bluetooth API is not available.\n' +
		// 		'Please make sure the "Experimental Web Platform features" flag is enabled.',
		// );
		return false;
	}
};

export const getSupportedProperties = (characteristic) => {
	let supportedProperties = [];
	for (const p in characteristic.properties) {
		if (characteristic.properties[p] === true) {
			supportedProperties.push(p.toUpperCase());
		}
	}
	return '[' + supportedProperties.join(', ') + ']';
};

export const toUTF8Array = (str) => {
	var utf8 = [];
	for (var i = 0; i < str.length; i++) {
		var charcode = str.charCodeAt(i);
		if (charcode < 0x80) utf8.push(charcode);
		else if (charcode < 0x800) {
			utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
		} else if (charcode < 0xd800 || charcode >= 0xe000) {
			utf8.push(
				0xe0 | (charcode >> 12),
				0x80 | ((charcode >> 6) & 0x3f),
				0x80 | (charcode & 0x3f),
			);
		}
		// surrogate pair
		else {
			i++;
			// UTF-16 encodes 0x10000-0x10FFFF by
			// subtracting 0x10000 and splitting the
			// 20 bits of 0x0-0xFFFFF into two halves
			charcode =
				0x10000 +
				(((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
			utf8.push(
				0xf0 | (charcode >> 18),
				0x80 | ((charcode >> 12) & 0x3f),
				0x80 | ((charcode >> 6) & 0x3f),
				0x80 | (charcode & 0x3f),
			);
		}
	}
	return utf8;
};



// WEBPACK FOOTER //
// ./src/utils/microbit.js